module.exports = __webpack_public_path__ + "img/platform_ownly_logo.03a14683.png";